<template>
	<div v-if="$route.query.index == 5" class="lottery_box">
		<div class="open_numver" v-if="showData.length > 0">
			<div class="numver_item">
				<div class="flash_panel" v-show="!showData[0].state">
					<ul class="commonam">
						<li v-for="n in 10" :key="n">{{ getRandomNum(0, 9) }}</li>
					</ul>
				</div>
				<span v-show="showData[0].state" :class="`n_${parseInt(showData[0].name)}`"></span>
			</div>
			<div class="symbol_font">+</div>
			<div class="numver_item">
				<div class="flash_panel" v-show="!showData[1].state">
					<ul class="commonam">
						<li v-for="n in 10" :key="n">{{ getRandomNum(0, 9) }}</li>
					</ul>
				</div>
				<span v-show="showData[1].state" :class="`n_${parseInt(showData[1].name)}`"></span>
			</div>
			<div class="symbol_font">+</div>
			<div class="numver_item">
				<div class="flash_panel" v-show="!showData[2].state">
					<ul class="commonam">
						<li v-for="n in 10" :key="n">{{ getRandomNum(0, 9) }}</li>
					</ul>
				</div>
				<span v-show="showData[2].state" :class="`n_${parseInt(showData[2].name)}`"></span>
			</div>
			<div class="symbol_font">=</div>
			<div class="numver_item">
				<div class="flash_panel" v-show="!showData[3].state">
					<ul class="commonam">
						<li v-for="n in 10" :key="n">{{ getRandomNum(0, 9) }}</li>
					</ul>
				</div>
				<span v-show="showData[3].state" :class="`n_${parseInt(showData[3].name)}`"></span>
			</div>
		</div>
	</div>
	<div class="lottery_box" v-else>
		<div class="open_numver">
			<div class="numver_item" v-for="(item, index) in showData" :key="index">
				<div class="flash_panel" v-show="!item.state">
					<ul class="commonam">
						<li v-for="n in 10" :key="n">{{ getRandomNum(0, 9) }}</li>
					</ul>
				</div>
				<span v-show="item.state" :class="`n_${parseInt(item.name)}`"></span>
			</div>
		</div>
	</div>
</template>

<script>
export default {
	name: "openNumber",
	props: {
		dataArray: {
			type: Object,
			required: true,
		},
	},
	data() {
		return {
			showData: [],
		};
	},
	created() {},
	watch: {
		dataArray(val) {
			let that = this;
			if (that.$route.query.index == 5) {
				if (val.arr.length <= 0) {
					that.showData = [];
					for (let i = 0; i < 4; i++) {
						that.showData.push({
							name: "?",
							state: false,
						});
					}
				} else {
					that.showData = val.arr.map((item, index) => {
						return {
							name: item,
							state: false,
						};
					});
				}
			} else {
				that.showData = val.arr.map(item => {
					return {
						name: item,
						state: false,
					};
				});
			}
			if (val.state) that.animationProcessing();
		},
	},
	methods: {
		//关闭动画
		animationProcessing() {
			this.showData.forEach((item, index) => {
				setTimeout(() => {
					item.state = true;
				}, 500 * (index + 1));
			});
		},
		getRandomNum(min, max) {
			return Math.floor(Math.random() * (max - min + 1)) + min;
		},
	},
};
</script>

<style lang="scss" scoped>
.lottery_box {
	width: auto;
	//height: 56px;
}

.open_numver {
	display: flex;
	justify-content: center;
	flex-wrap: nowrap;
	width: auto;
	margin-top: 5px;
	div.numver_item {
		position: relative;
		width: 50px;
		height: 50px;
		text-align: center;
		cursor: pointer;
		// background: url("~@/static/img/moreNumber/n_bg.png");
		background-size: contain;
		box-shadow: 0px 4px 4px 0 rgba(0, 0, 0, 0.25);
		background-color: #fff;
		border-radius: 50%;
		margin: 0 10px;

		.flash_panel {
			width: 50px;
			overflow: hidden;
			height: 50px;
			margin: 2px auto;
		}

		ul {
			list-style: none;
			width: 100%;
			padding: 0;
			margin: 0;

			li {
				width: 50px;
				height: 46px;
				text-align: center;
				line-height: 46px;
				font-size: 26px;
				color: #494949;
			}
		}

		span {
			display: block;
			width: 100%;
			height: 100%;
			background-size: 100% 100%;
			background-repeat: no-repeat;
		}

		span::before {
			position: absolute;
			top: 4px;
			left: 50%;
			transform: translate(-50%, 0%);
			font-family: "Acre";
			font-size: 26px;
			// font-weight: 500;
			font-weight: 400;
			color: #494949;
		}

		.n_0::before {
			content: "0";
		}

		.n_1::before {
			content: "1";
		}

		.n_2::before {
			content: "2";
		}

		.n_3::before {
			content: "3";
		}

		.n_4::before {
			content: "4";
		}

		.n_5::before {
			content: "5";
		}

		.n_6::before {
			content: "6";
		}

		.n_7::before {
			content: "7";
		}

		.n_8::before {
			content: "8";
		}

		.n_9::before {
			content: "9";
		}

		.n_10::before {
			content: "10";
		}

		.n_11::before {
			content: "11";
		}

		.n_12::before {
			content: "12";
		}

		.n_13::before {
			content: "13";
		}

		.n_14::before {
			content: "14";
		}

		.n_15::before {
			content: "15";
		}

		.n_16::before {
			content: "16";
		}

		.n_17::before {
			content: "17";
		}

		.n_18::before {
			content: "18";
		}

		.n_19::before {
			content: "19";
		}

		.n_20::before {
			content: "20";
		}

		.n_21::before {
			content: "21";
		}

		.n_22::before {
			content: "22";
		}

		.n_23::before {
			content: "23";
		}

		.n_24::before {
			content: "24";
		}

		.n_25::before {
			content: "25";
		}

		.n_26::before {
			content: "26";
		}

		.n_27::before {
			content: "27";
		}
	}
}

.commonam {
	animation: gundong 1s linear infinite reverse;
}

@keyframes gundong {
	0% {
		margin-top: 0;
	}
	100% {
		margin-top: -440px;
	}
}

.symbol_font {
	width: auto !important;
	height: 50px;
	line-height: 50px;
	margin: 0 4px;
	font-size: 36px;
	color: #fff;
	// font-weight: 600;
	font-weight: 400;
}
</style>



// WEBPACK FOOTER //
// src/components/common/openNumber.vue